export default __webpack_public_path__ + "static/media/EmptyHistory.bcdb5df4.png";